import { LocaleCode } from '@tink/config/src/markets';

export const getTermsAndConditionsUrl = (clientId: string, locale?: LocaleCode) =>
  locale
    ? `https://cdn.tink.se/link/configuration/oxford-production/${clientId}/legal/${locale}/terms-and-conditions.html`
    : `https://cdn.tink.se/link/configuration/oxford-production/${clientId}/legal/terms-and-conditions.html`;

export const getPrivacyPolicyUrl = (clientId: string, locale?: LocaleCode) =>
  locale
    ? `https://cdn.tink.se/link/configuration/oxford-production/${clientId}/legal/${locale}/privacy-policy.html`
    : `https://cdn.tink.se/link/configuration/oxford-production/${clientId}/legal/privacy-policy.html`;
